module.exports = __webpack_public_path__ + "static/img/portrait.a9e6428.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portrait.png
// module id = DXJi
// module chunks = 118